import App from "./App";
import { connect } from "react-redux";
import { compose } from "redux";

import { RootState } from "store/store";
import {
    setModalMessage,
    setModalTitle,
} from "store/common/modal-window/modal-window-slices";
import { setUserName } from "store/authentication/authentication-actions";

const mapStateToProps = (state: RootState) => {
    return {
        isAppSettingsFetched: state.appSettingsReducer.isAppSettingsFetched,
    };
};

const AppContainer = compose(
    connect(mapStateToProps, {
        setModalTitle,
        setModalMessage,
        setUserName,
    })
)(App);

export default AppContainer;
